<div *ngIf="from && to" [class.text-danger]="difference < 0" class="project-hour-difference">
  <i class="fas fa-exclamation-triangle" *ngIf="difference < 0"></i> {{ from | timeDifference : to }}
</div>
